@if (showFilialSelect || showAlways) {
  <div class="form-control" @fadeInOut>
    <label for="filial">{{ 'FILIAL_LABEL' | translate }}</label>
    <ng-select
      [items]="items"
      autocomplite="filial"
      [loading]="isLoading"
      [multiple]="false"
      [placeholder]="'NO_FILIAL_PlACEHOLDER' | translate"
      [notFoundText]="'NOT_FOUND' | translate"
      [clearAllText]="'CLEAR_ALL_SELECT' | translate"
      [loadingText]="'loading' | translate"
      [searchable]="true"
      [searchFn]="customSearchFn"
      bindLabel="code"
      bindValue="code"
      (change)="updateValue(value)"
      [(ngModel)]="value"
    >
      <ng-template ng-label-tmp let-item="item">
        {{ item.name }}
        <span class="font-weight-medium"
          >({{ item.code ? item.code : ('MAIN_OFFICE' | translate) }})</span
        >
      </ng-template>
      <ng-template
        ng-option-tmp
        let-item="item"
        let-index="index"
        let-search="searchTerm"
      >
        {{ item.name }}
        <span class="font-weight-medium"
          >({{ item.code ? item.code : ('MAIN_OFFICE' | translate) }})</span
        >
      </ng-template>
    </ng-select>
    <ng-content></ng-content>
  </div>
}
